const namespace = 'Connections';

export const FETCH_CONNECTION = `${namespace}/FETCH_CONNECTION`;
export const FETCH_CONNECTION_FAILURE = `${namespace}/FETCH_CONNECTION_FAILURE`;
export const FETCH_CONNECTION_SUCCESS = `${namespace}/FETCH_CONNECTION_SUCCESS`;

export const SET_SORTER = `${namespace}/SET_SORTER`;
export const SET_WAY = `${namespace}/SET_WAY`;

export const SET_OPENED_CONNECTION_DETAIL = `${namespace}/SET_OPENED_CONNECTION_DETAIL`;

export const FETCH_DETAIL = `${namespace}/FETCH_DETAIL`;
export const FETCH_DETAIL_FAILURE = `${namespace}/FETCH_DETAIL_FAILURE`;
export const FETCH_DETAIL_SUCCESS = `${namespace}/FETCH_DETAIL_SUCCESS`;

export const FETCH_NEXT_CONNECTIONS = `${namespace}/FETCH_NEXT_CONNECTIONS`;
export const FETCH_NEXT_CONNECTION_FAILURE = `${namespace}/FETCH_NEXT_CONNECTION_FAILURE`;
export const FETCH_NEXT_CONNECTION_SUCCESS = `${namespace}/FETCH_NEXT_CONNECTION_SUCCESS`;

export const FETCH_PREV_CONNECTIONS = `${namespace}/FETCH_PREV_CONNECTIONS`;
export const FETCH_PREV_CONNECTION_FAILURE = `${namespace}/FETCH_PREV_CONNECTION_FAILURE`;
export const FETCH_PREV_CONNECTION_SUCCESS = `${namespace}/FETCH_PREV_CONNECTION_SUCCESS`;



// WEBPACK FOOTER //
// ./src/containers/Connections/constants.js